import { Link } from 'react-router-dom';

import { Badge, Button } from '@motorway/mw-highway-code';

import { AgentsBoxCard, useSessionMode } from '@motorway/motorway-handshake-components';

import { Header } from '../../components/Header/Header';
import { Logo } from '../../components/Logo/Logo';
import { MessagingList, MESSAGING_LIST_FORMATTERS } from '../../components/MessagingList/MessagingList';
import { VehicleSummary } from '../../components/VehicleSummary/VehicleSummary';
import { ROUTES } from '../../helpers/routes';
import { snowplowClick, snowplowCtaClick } from '../../helpers/snowplow';

import styles from './Inspection.module.scss';

export const Inspection = () => {
  const { IS_FULL_SESSION, IS_LITE_SESSION } = useSessionMode();

  const TITLE = IS_LITE_SESSION ? 'Collection in progress' : 'Inspect the vehicle';
  const SUBTITLE = IS_LITE_SESSION
    ? 'Once the seller has received payment, you can complete the collection.'
    : 'Once the inspection is done, you\'ll send a report for the seller to accept.';
  const CTA_LABEL = IS_LITE_SESSION ? 'Complete collection' : 'Send inspection report';

  return (
    <div className={styles.component}>
      <Logo />
      <div className={styles.liveBadge}>
        <Badge variant="error" text="LIVE" className={styles.liveBadge} />
      </div>
      <Header className={styles.header}>
        <h1>{TITLE}</h1>
        <p>{SUBTITLE}</p>
      </Header>
      <div className={styles.inspectionComplete}>
        <Button
          as={Link}
          fullWidth
          {...(IS_FULL_SESSION && { icon: 'arrow' })}
          label={CTA_LABEL}
          onClick={() => {
            snowplowCtaClick({
              button_label: CTA_LABEL,
              name: 'send_inspection_report_clicked',
              url: ROUTES.OUTCOME,
            });
          }}
          showLabel
          size="medium"
          to={ROUTES.OUTCOME}
          type="button"
          variant="primary"
        />
      </div>

      <VehicleSummary clickCallback={snowplowClick} />
      <AgentsBoxCard clickCallback={snowplowCtaClick} />
      {IS_FULL_SESSION && <MessagingList formatter={MESSAGING_LIST_FORMATTERS.PRICE_DETAILS} />}
    </div>
  );
};
